import React, { useEffect, useState } from "react";
import {
    api, getAddressOfOrder, getCountries, getTicketTypeById, getTicketTypeInfosByTicketTypeId,
    getTicketTypeNumberOfAvailableTickets, getTicketTypePriceForOrder, getOccupancy, getTicketsOfOrder, getSeatBySeatId
} from "ticketino-api-client";
import axios from 'axios';

import Loading from "./Loading";
import { Cart, CartFill } from "react-bootstrap-icons";

/* eslint eqeqeq: "off" */

const CustomerForm = (props) => {

    //----variables----

    //developement env dependent
    const baseUrl = process.env.REACT_APP_BASE_TICKETINO_URL;
    const baseProxyUrl = process.env.REACT_APP_PLUGIN_PROXY;

    //prop values
    const orderId = props.orderId;
    const token = props.token;
    const selectedFields = props.selectedFields;
    const selectedLanguageCode = props.languageCode;
    const changeLanguage = props.changeLanguage;
    const selectedLanguage = props.languageISO;
    const ticketTypesInformation = props.ticketTypesInformation;
    const showTicketTypesAsList = props.showTicketTypesAsList;
    const singleTicketAsCB = props.singleTicketAsCB;
    const showTicketDescription = props.showTicketDescription;
    const disableTickets = props.disableTickets ?? "";
    const enableTickets = props.enableTickets ?? "";

    //mutateable
    const [user, setUser] = useState({
        salutation: "",
        firstName: "",
        name: "",
        email: "",
        emailCheck: "",
        street: "",
        city: "",
        postCode: "",
        countryId: 176,
        telephone: "",
        mobile: "",
        company: "",
        deliveryActive: false,
        deliverySalutation: "",
        deliveryFirstName: "",
        deliveryLastName: "",
        deliveryCompanyName: "",
        deliveryStreet: "",
        deliveryCity: "",
        deliveryPostCode: "",
        deliveryCountryId: ""
    });

    const [tickets, setTickets] = useState([]);
    const [ticketsAddress, setTicketsAddress] = useState([]);

    const [userAcceptAGB, setUserAcceptAGB] = useState(false);
    const [countryArray, setCountryArray] = useState([]);
    const [neededFields, setNeededFields] = useState([]);

    const [errorMessage, setErrorMessage] = useState("");
    const [resources, setResources] = useState([]);

    const [loading, setLoading] = useState(true);
    const [fieldControls, setFieldControls] = useState([]);
    const [fields, setFields] = useState([]);
    const [crossSellingTicketTypes, setCrossSellingTicketTypes] = useState([]);

    const [disabledTickets, setDisabledTickets] = useState([]);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        api.defaults.baseURL = baseUrl;

        if (selectedFields == null) {
            setNeededFields(["firstName", "name", "countryId", "postCode", "city", "salutation", "street", "deliveryAddress"])
        } else {
            setNeededFields(selectedFields.split(";"));
        }

        scrollView();
        loadOrder(orderId);
    }, []);

    useEffect(() => {
        requestResources(selectedLanguage);
        loadCountries(selectedLanguage);
        requestFieldControls(selectedLanguage);
        requestFields(selectedLanguage);
    }, [selectedLanguage]);

    const requestResources = async (langauge) => {
        await axios
            .get(`${baseProxyUrl}/resources/${langauge}`)
            .then((res) => {
                setResources(res.data);
            })
            .catch((error) => console.error(error.response.data));
    };

    const requestFieldControls = async (language) => {
        await axios.get(`${baseUrl}/Ticket/FieldControls?languageCode=${language}`)
            .then((res) => {
                setFieldControls(res.data.ticketFieldControls);
            })
            .catch((error) => console.error(error.response.data));
    }

    const requestFields = async (language) => {
        await axios.get(`${baseUrl}/Ticket/Fields?languageCode=${language}`)
            .then((res) => {
                setFields(res.data.ticketFields);
            })
            .catch((error) => console.error(error.response.data));
    }

    const loadOrder = async (orderId, reload) => {
        try {
            const order = await getOrderByOrderId(orderId);
            const address = await getAddressOfOrder(orderId);

            const updatedAddress = {
                salutation: address.salutation ?? "",
                firstName: address.firstName ?? "",
                name: address.name ?? "",
                email: address.email ?? "",
                emailCheck: "",
                street: address.street ?? "",
                city: address.city ?? "",
                postCode: address.postCode ?? "",
                countryId: address.countryId ?? 176,
                telephone: address.telephone ?? "",
                mobile: address.mobile ?? "",
                company: address.company ?? "",
                deliveryActive: address.deliveryActive ?? false,
                deliverySalutation: address.deliverySalutation ?? "",
                deliveryFirstName: address.deliveryFirstName ?? "",
                deliveryLastName: address.deliveryLastName ?? "",
                deliveryCompanyName: address.deliveryCompanyName ?? "",
                deliveryStreet: address.deliveryStreet ?? "",
                deliveryCity: address.deliveryCity ?? "",
                deliveryPostCode: address.deliveryPostCode ?? "",
                deliveryCountryId: address.deliveryCountryId ?? 176
            }

            if (order) {
                const tickets = await getTicketsOfOrder(orderId);

                const updatedTickets = await Promise.all(
                    tickets.map(async (ticket) => {
                        const ticketType = ticketTypesInformation.find((tti) => tti.id == ticket.ticketTypeId) ?? await getTicketTypeById(ticket.ticketTypeId);
                        const info = ticketTypesInformation.find((tti) => tti.id == ticket.ticketTypeId)?.info ?? await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);

                        return { ...ticket, ticketType: ticketType, info: info }
                    })
                )

                const updatedTicketsAddress = await Promise.all(tickets.map(async (ticket) => {

                    let seatDetails = {};
                    if (ticket.occupancyId != null && ticket.occupancyId > 0) {
                        let occupancy =  await getOccupancy(ticket.occupancyId);
                        if (occupancy) {
                            seatDetails = await getSeatBySeatId(occupancy.seatId);
                        }
                    }

                    const updatedTicket = {
                        ticketId: ticket.id,
                        seatDetails: seatDetails,
                        salutation: ticket.salutation ?? "",
                        company: ticket.company ?? "",
                        firstName: ticket.firstName ?? "",
                        lastName: ticket.lastName ?? "",
                        email: ticket.email ?? "",
                        street: ticket.street ?? "",
                        postCode: ticket.postCode ?? "",
                        city: ticket.city ?? "",
                        mobile: ticket.mobile ?? "",
                        customValue1: ticket.customValue1 ?? "",
                        customValue2: ticket.customValue2 ?? "",
                        customValue3: ticket.customValue3 == null ? false : false,
                        customValue4: ticket.customValue4 == null ? false : false,
                        ...ticket
                    }

                    return { ...updatedTicket }
                }));

                let crossSellingTicketTypeIds = await Promise.all(
                    updatedTickets.map(async (updatedTicket) => {
                        return await getGetCrossSellingTicketTypes(updatedTicket.ticketTypeId);
                    })
                );

                crossSellingTicketTypeIds = crossSellingTicketTypeIds.flat();

                crossSellingTicketTypeIds = [...new Set(crossSellingTicketTypeIds)];

                let crossSellingTicketTypes = [];


                if (crossSellingTicketTypeIds) {

                    crossSellingTicketTypes = await Promise.all(
                        crossSellingTicketTypeIds.map(async (crossSellingTicketTypeId) => {

                            let ticketType = await getTicketTypeById(crossSellingTicketTypeId);

                            if (!ticketType) return null;

                            let info = await getTicketTypeInfosByTicketTypeId(crossSellingTicketTypeId);
                            // sorting it according to the language
                            ticketType.info = info;

                            let ticketTypeAvailability = await getTicketTypeNumberOfAvailableTickets(crossSellingTicketTypeId, orderId);

                            ticketType.availability = ticketTypeAvailability;

                            let ticketTypePrice = await getTicketTypePriceForOrder(orderId, ticketType.id);

                            ticketType.updatedPrice = ticketTypePrice;
                            // setting the ticketTypeInfo and ticketTypeAvailability object as attributes in ticketType (info and availability)
                            return ticketType;
                        })
                    )
                }


                console.log(tickets);
                setUser({ ...updatedAddress });
                setTickets(updatedTickets);
                setTicketsAddress(updatedTicketsAddress);
                setCrossSellingTicketTypes(crossSellingTicketTypes);

                setLoading(false);
            } else {
                props.changeOrderId(0);
                props.changePage(-1);
            }

        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    }

    //updates the disabled ticket array
    const updateDisabledTickets = (amount, ticketTypeIdGiven) => {
        let ticketTypesToBeDisabled = [];

        if (amount > 0) {
            disableTickets.split("|").map((ticketGroup) => {

                let ticketTypeIds = ticketGroup.split(";");

                if (ticketTypeIds[0] == `${ticketTypeIdGiven}`) {
                    for (var i = 0; i < ticketTypeIds.length; i++) {
                        ticketTypesToBeDisabled.push(ticketTypeIds[i + 1]);
                    }
                }
            });
        }
        setDisabledTickets(ticketTypesToBeDisabled);
    }


    const onCrossSellingTicketTypeChange = (e, ticketTypeId) => {

        addCrossSellingTicketsToBasket(ticketTypeId, e.target.value);

        // calcualate quantity and validate
        let quantity = e.target.value;

        //add quantity from order tickets

        updateDisabledTickets(quantity, ticketTypeId);
    };

    const loadCountries = async (language) => {
        try {
            let countries = await getCountries(language.trim());

            const indexCH = countries.findIndex(c => c.id === 176);
            const ch = countries[indexCH];
            countries.splice(indexCH, 1);

            var indexDE = countries.findIndex(c => c.id === 229);
            const de = countries[indexDE];
            countries.splice(indexDE, 1);

            var indexAU = countries.findIndex(c => c.id === 228);
            const au = countries[indexAU];
            countries.splice(indexAU, 1);

            countries.unshift({ id: 0, name: "---------" });
            countries.unshift(au);
            countries.unshift(de);
            countries.unshift(ch);

            setCountryArray(countries);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }
       

    const getGetCrossSellingTicketTypes = async (ticketTypeId) => {
        try {
            const res = await axios.get(`${baseUrl}/TicketType/${ticketTypeId}/CrossSelling`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const addTicketsToShopBasket = async (orderId, ticketstoAdd) => {
        try {
            const response = await axios.post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, { ticketstoAdd: ticketstoAdd });
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setErrorMessage(resources.ticketPage?.generalErrorMessage)
        }
    }

    const updateAddress = async () => {

        const isOrderAddressValid = validateOrderAddress();
        const isTicketAddressValid = validateTicketAddress();

        if (isOrderAddressValid && isTicketAddressValid) {

            await updateAddressOfOrder();
            await updateAddressOfTicket();

            props.changePage(1);
        }
    }

    const updateAddressOfOrder = async () => {
        let updateAddressBody = { ...user };

        const response = await axios.put(`${baseUrl}/Order/${orderId}/Address`, updateAddressBody)
            .then(() => {
                return true;
            }).catch((error) => {
                console.error(error);
                return false
            });
    }

    const updateAddressOfTicket = async () => {
        try {
            await Promise.all(
                ticketsAddress.map(async (ticketAddress) => {

                    //remove this when we remove 'lastname' and 'firstname' from ticket apimodel
                    ticketAddress.firstname = ticketAddress.firstName;
                    ticketAddress.lastname = ticketAddress.lastName;

                    const updateTicketBody = { ...ticketAddress };

                    try {
                        await axios.put(
                            `${baseUrl}/Ticket/${ticketAddress.ticketId}/Address`,
                            updateTicketBody
                        );
                        return true;
                    } catch (error) {
                        console.error(`Error updating ticket ${ticketAddress.ticketId}:`, error);
                        return false;
                    }
                })
            );
        } catch (error) {
            console.error("Unexpected error in updateAddressOfTicket:", error);
        }
    };

    const removeTicketFromBasket = async (ticketId) => {
        let removeTicketBody = {
            "TicketsToRemove": [
                ticketId
            ]
        }

        await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`,
            {
                headers: { Accept: "application/json", },
                data: removeTicketBody
            })
            .then(() => {
                loadOrder(orderId, true);
            }).catch((err) => {
                setErrorMessage(resources.summarypage?.generalError);
            })
    }


    const onInputChangeOrder = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    }

    const onInputChangeTicket = (e, ticketId) => {
        setTicketsAddress((prevTicketsAddress) => {
            const updatedTicketAddress = prevTicketsAddress.map((ta) => {
                if (ta.ticketId === ticketId) {

                    if (e.target.name === "mobile") {
                        return { ...ta, [e.target.name]: e.target.value, "phone": e.target.value };
                    }

                    return { ...ta, [e.target.name]: e.target.value };
                }
                return ta;
            });
            return updatedTicketAddress;
        });
    }

    //scroll to top of plugin
    const scrollView = () => {
        var scrollElement = document.getElementById("ticketinoScrollElement");

        if (scrollElement) {
            scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    //change the user selected langauge
    const updateLanguage = (language) => {
        requestResources(language);
        changeLanguage(language)
    }


    const addCrossSellingTicketsToBasket = async (ticketTypeId, quantity) => {

        let canContinue = true;

        if (!(quantity > 0)) {
            return;
        }

        if (disabledTickets.includes(`${ticketTypeId}`)) {
            setErrorMessage(resources.ticketPage?.errorMessageDisabledTicketSelected);
            canContinue = false;
        }

        if (canContinue) {

            const crossSellingTicketTypeToAdd = [{
                ticketTypeId: ticketTypeId,
                quantity: quantity,
            }];

            const order = await addTicketsToShopBasket(orderId, crossSellingTicketTypeToAdd);

            if (order) {
                loadOrder(order.id, true);
            }
        }
    }

    const languageSelectDiv = () => {
        return (
            <div className="container">
                <div className="row justify-content-end">
                    <div className="col-auto">
                        <select
                            className="ticketinoSelect selectNum form-select"
                            aria-label=""
                            value={selectedLanguage}
                            onChange={(e) => {
                                updateLanguage(e.currentTarget.value);
                            }}>
                            <option value={"en"} key={1} >{"en"}</option>
                            <option value={"de"} key={2} >{"de"}</option>
                            <option value={"fr"} key={3} >{"fr"}</option>
                            <option value={"it"} key={4} >{"it"}</option>

                        </select>
                    </div>
                    <div className="col-auto mb-4 text-end">
                        <div type="button" className="btn btn-light position-relative fs-6">
                            <Cart />
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                {tickets?.length}
                            </span>
                        </div>
                    </div>
                </div>
                <p className="ticketinoText text titleStyle text-start text-center fs-3 fw-semibold mb-2">{resources.customerPage?.title}</p>
                <p className="ticketinoText text fs-6 text-center">{resources.customerPage?.instruction}</p>
                {(!(tickets?.length > 0) & !loading) ? <div className="alert alert-danger" role="alert">
                    {resources.summarypage?.noTicketSelectedError}
                </div> : null}
                {(!(tickets) & !loading) ? <div className="alert alert-warning" role="alert">
                    {resources.summarypage?.reserveTicket}
                </div> : null}
            </div>
        )
    }

    const validateField = (object, property, ticketId) => {
        var element = document.getElementById(property);

        if (ticketId > 0) {
            element = document.getElementById(property + ticketId);
        }

        if (!(object[property] && (object[property].toString().trim().length > 0))) {
            if (element) element.style.border = "1px solid red";
            return false;
        }

        if (element) element.style.border = "1px solid #dee2e6";

        return true;
    }

    const validateEmail = (object, property, ticketId) => {
        var element = document.getElementById(property);

        if (ticketId > 0) {
            element = document.getElementById(property + ticketId);
        }

        if ((/^\S+@\S+\.\S+$/.test(object[property]) == false)) {
            if (element) element.style.border = "1px solid red";
            return false;
        }

        if (element) element.style.border = "1px solid #dee2e6";
        return true;
    }

    const validateOrderAddress = () => {
        setErrorMessage("");
        let isValid = true;
        let errors = [];

        Object.entries(user).map(([key]) => {
            if (neededFields.includes(`${key}`)) {
                if (key == "countryId") {
                    if (!(user.countryId > 0)) { isValid = false; };
                } else {
                    isValid = validateField(user, key);
                }
            }

            if (neededFields.includes(`deliveryAddress`)) {
                if (user.deliveryActive) {
                    if (key == "deliveryActive") {
                        isValid = user.deliveryActive;
                    } else if (key.startsWith(`delivery`)) {
                        if (key == "deliveryCompanyName") {
                        } else {
                            isValid = validateField(user, key);
                        }
                    }
                }
            }

            if (!isValid) {
                errors.push(key);
            }
        })

        isValid = validateEmail(user, "email");

        var element = document.getElementById("emailCheck");

        if (user.email != user.emailCheck) {
            if (element) element.style.border = "1px solid red";

            isValid = false;
        } else {
            if (element) element.style.border = "1px solid #dee2e6"
        }

        if (errors.length > 0) {
            isValid = false;
        }

        if (!isValid) {
            setErrorMessage(resources.customerPage?.fieldMessage);
        }

        return isValid;
    }

    const validateTicketAddress = () => {
        setErrorMessage("");
        let errors = [];

        ticketsAddress.forEach((ticketAddress) => {
            let hasValidTicketAddress = true;
            const selectedTicket = tickets.find(t => t.id === ticketAddress.ticketId);
            const additionalFields = selectedTicket.ticketType?.additionalFields ?? [];

            // Validate mandatory standard fields
            Object.entries(ticketAddress).forEach(([key]) => {
                if (selectedTicket.ticketType[`${key}Mandatory`] === true) {
                    hasValidTicketAddress = hasValidTicketAddress && validateField(ticketAddress, key, ticketAddress.ticketId);

                    if (key === "email") {
                        hasValidTicketAddress = hasValidTicketAddress && validateEmail(user, "email", ticketAddress.ticketId);
                    }
                }
            });

            // Validate mandatory additional fields
            additionalFields.forEach((additionalField) => {
                if (additionalField?.isMandatory) {
                    const saveToFieldString = fields.find(f => f.id === additionalField.saveToField)?.description ?? "Option1";
                    const saveToField = saveToFieldString.charAt(0).toLowerCase() + saveToFieldString.slice(1);
                    hasValidTicketAddress = hasValidTicketAddress && validateField(ticketAddress, saveToField, ticketAddress.ticketId);
                }
            });


            const selectedTicketInfo = selectedTicket.info?.find(info => info.languageId === selectedLanguageCode) ??
                selectedTicket.info?.find(info => info.languageId === 0);
            if (selectedTicketInfo?.customText1Mandatory === true) {
                hasValidTicketAddress = hasValidTicketAddress && validateField(ticketAddress, "customValue1", ticketAddress.ticketId);
            }
            if (selectedTicketInfo?.customText2Mandatory === true) {
                hasValidTicketAddress = hasValidTicketAddress && validateField(ticketAddress, "customValue2", ticketAddress.ticketId);
            }


            if (!hasValidTicketAddress) {
                errors.push(`key${ticketAddress.ticketId}`);
            }
        });

        const isValid = errors.length === 0;

        if (!isValid) {
            setErrorMessage(resources.customerPage?.fieldMessage);
        }

        return isValid;
    };

    const mapAdditionalFields = (field, address) => {
        const fieldControl = field.fieldControl;
        const fieldTitle = field?.title[selectedLanguageCode] ?? field.title[1];

        const fieldOptions = field?.options?.map((option) => {
            option.text = option?.optionValues[selectedLanguageCode] ?? option?.optionValues[1]
            return option;
        }) ?? [];

        let saveToFieldString = fields.find((f) => f.id == field.saveToField)?.description ?? "Option1";
        const saveToField = saveToFieldString.charAt(0).toLowerCase() + saveToFieldString.slice(1);
        const isMandatory = field?.isMandatory ? "*" : "";

        // RadioButtonList
        if (fieldControl == 0) {
            return (
                <div className="mb-3">
                    <p className="mb-2">{fieldTitle}{isMandatory}</p>
                    {
                        fieldOptions?.length > 0 && fieldOptions.map((option) => (
                            <>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name={saveToField + address.ticketId}
                                        id={saveToField + address.ticketId}
                                        checked={address[saveToField]?.split(";")[0] == option?.text}
                                        onChange={(e) => {
                                            setTicketsAddress((prevTicketsAddress) => {
                                                const updatedTicketAddress = prevTicketsAddress.map((ta) => {
                                                    let values = ta[saveToField]?.split(";") ?? [];
                                                    values[0] = option?.text;

                                                    if (!option?.hasOptionText) {
                                                        values.splice(1, 1);
                                                    }

                                                    if (ta.ticketId === address.ticketId) {
                                                        return { ...ta, [saveToField]: values.join(";") };
                                                    }
                                                    return ta;
                                                });
                                                return updatedTicketAddress;
                                            });
                                        }}
                                    />
                                    <label className="form-check-label" for={saveToField + address.ticketId}>
                                        {option?.text}
                                    </label>
                                </div>
                                {(option?.hasOptionText && address[saveToField]?.split(";")[0] == option?.text) &&
                                    <input
                                        className="form-control mt-2"
                                        type="text"
                                        name={saveToField}
                                        id={saveToField + address.ticketId}
                                        value={address[saveToField]?.split(";")[1]}
                                        onChange={(e) => {
                                            setTicketsAddress((prevTicketsAddress) => {
                                                const updatedTicketAddress = prevTicketsAddress.map((ta) => {
                                                    let values = ta[saveToField]?.split(";") ?? [];
                                                    values[1] = e.target.value;
                                                    if (ta.ticketId === address.ticketId) {
                                                        return { ...ta, [saveToField]: values.join(";") };
                                                    }
                                                    return ta;
                                                });
                                                return updatedTicketAddress;
                                            });
                                        }} />
                                }
                            </>
                        ))
                    }
                </div>
            )
        }

        // CheckboxList
        if (fieldControl == 1) {
            return (
                <div className="mb-3">
                    {/*<p className="mb-2">{fieldTitle}{isMandatory}</p>*/}
                    {
                        fieldOptions?.length > 0 && fieldOptions.map((option) => (
                            <>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name={saveToField}
                                        id={saveToField + address.ticketId}
                                        checked={address[saveToField]?.split(";")?.includes(option?.text) ?? false}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setTicketsAddress((prevTicketsAddress) => {
                                                    const updatedTicketAddress = prevTicketsAddress.map((ta) => {
                                                        let values = ta[saveToField]?.split(";") ?? [];
                                                        values.push(option?.text)
                                                        if (ta.ticketId === address.ticketId) {
                                                            return { ...ta, [saveToField]: values.join(";") };
                                                        }
                                                        return ta;
                                                    });
                                                    return updatedTicketAddress;
                                                });
                                            } else {
                                                setTicketsAddress((prevTicketsAddress) => {
                                                    const updatedTicketAddress = prevTicketsAddress.map((ta) => {
                                                        let values = ta[saveToField].split(";") ?? [];

                                                        if (option?.hasOptionText) {
                                                            const textIndex = values.indexOf(option.text) + 1;
                                                            if (textIndex < values.length) {
                                                                values[textIndex] = "";
                                                            }
                                                        }

                                                        values = values.filter((v) => v != option?.text);

                                                        if (ta.ticketId === address.ticketId) {
                                                            return { ...ta, [saveToField]: values.filter(v => v?.length > 0).join(";") };
                                                        }
                                                        return ta;
                                                    });
                                                    return updatedTicketAddress;
                                                });
                                            }
                                        }}
                                    />
                                    <label className="form-check-label" for="flexCheckDefault">
                                        {option?.text} {isMandatory}
                                    </label>
                                </div>
                                {((option?.hasOptionText) && address[saveToField]?.split(";")?.includes(option?.text)) &&
                                    <input
                                        className="form-control mt-2"
                                        type="text"
                                        disabled={!address[saveToField]?.split(";")?.includes(option?.text)}
                                        name={saveToField}
                                        id={saveToField + address.ticketId}
                                        value={address[saveToField]?.split(";")[address[saveToField]?.split(";").indexOf(option.text) + 1] ?? ""}
                                        onChange={(e) => {
                                            const newTextValue = e.target.value;
                                            setTicketsAddress((prevTicketsAddress) => {
                                                const updatedTicketAddress = prevTicketsAddress.map((ta) => {
                                                    let values = ta[saveToField]?.split(";") ?? [];
                                                    const index = values.indexOf(option.text);
                                                    if (index !== -1) {
                                                        values[index + 1] = newTextValue;
                                                        if (ta.ticketId === address.ticketId) {
                                                            return { ...ta, [saveToField]: values.join(";") };
                                                        }
                                                    }
                                                    return ta;
                                                });
                                                return updatedTicketAddress;
                                            });
                                        }} />
                                }
                            </>
                        ))
                    }
                </div>
            )
        }

        // Dropdown
        if (fieldControl == 2) {
            return (
                <div className="mb-3">
                    <p className="mb-2">{fieldTitle}{isMandatory}</p>
                    {
                        <select
                            className="form-select"
                            name={saveToField}
                            id={saveToField + address.ticketId}
                            value={address[saveToField]}
                            onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                        >
                            <option selected>Open this select menu</option>
                            {fieldOptions?.length > 0 && fieldOptions.map((option) => (
                                <option value={option?.text}>{option?.text}</option>
                            ))}
                        </select>
                    }
                </div>
            )
        }

        // Textbox
        if (fieldControl == 3) {
            return (
                <div className="mb-3">
                    <label for={saveToField + address.ticketId} className="form-label">{fieldTitle}{isMandatory}</label>
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Textbox"
                        name={saveToField}
                        id={saveToField + address.ticketId}
                        value={address[saveToField]}
                        onChange={(e) => onInputChangeTicket(e, address.ticketId)} />
                </div>
            )
        }

        // MultilineTextbox
        if (fieldControl == 4) {
            return (
                <div className="mb-3">
                    <label for={saveToField + address.ticketId} className="form-label">{fieldTitle}{isMandatory}</label>
                    <textarea
                        className="form-control"
                        rows="3"
                        name={saveToField}
                        id={saveToField + address.ticketId}
                        value={address[saveToField]}
                        onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                    ></textarea>
                </div>
            )
        }

        // EmailTextbox
        if (fieldControl == 5) {
            return (
                <div className="mb-3">
                    <label for={saveToField + address.ticketId} className="form-label">{fieldTitle}{isMandatory}</label>
                    <input
                        type="email"
                        className="form-control"
                        name={saveToField}
                        id={saveToField + address.ticketId}
                        value={address[saveToField]}
                        onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                        placeholder="name@example.com" />
                </div>
            )
        }

        // TelephoneNumberTextbox
        if (fieldControl == 6) {
            return (
                <div className="mb-3">
                    <label for={saveToField + address.ticketId} className="form-label">{fieldTitle}{isMandatory}</label>
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Telephone number textbox"
                        name={saveToField}
                        id={saveToField + address.ticketId}
                        value={address[saveToField]}
                        onChange={(e) => onInputChangeTicket(e, address.ticketId)} />
                </div>
            )
        }

        // Text label
        if (fieldControl == 7) {
            return (
                <div className="mb-3">
                    <p className="mb-2">{fieldTitle}</p>
                </div>
            )
        }
    }

    const mapTicketsAddress = () => {
        console.log(ticketsAddress);

        return (
            <div className="container mb-5 ticketAddressContainer">
                {ticketsAddress.length > 0 &&
                    ticketsAddress.map((address) => {

                        const selectedTicket = tickets.find(t => t.id == address.ticketId);

                        const selectedTicketInfo = selectedTicket.info?.find(info => info.languageId === selectedLanguageCode) ?? selectedTicket.info?.find(info => info.languageId === 0);

                        const additionalFields = selectedTicket.ticketType?.additionalFields;

                        const isAddressRequired = (selectedTicket.ticketType.salutationMandatory == true || selectedTicket.ticketType.salutationRequired == true)
                            || (selectedTicket.ticketType.companyMandatory == true || selectedTicket.ticketType.companyRequired == true)
                            || (selectedTicket.ticketType.firstNameMandatory == true || selectedTicket.ticketType.firstNameRequired == true)
                            || (selectedTicket.ticketType.nameMandatory == true || selectedTicket.ticketType.nameRequired == true)
                            || (selectedTicket.ticketType.addressMandatory == true || selectedTicket.ticketType.addressRequired == true)
                            || (selectedTicket.ticketType.postalCodeAndCityMandatory == true || selectedTicket.ticketType.postalCodeAndCityRequired == true)
                            || (selectedTicket.ticketType.postalCodeAndCityMandatory == true || selectedTicket.ticketType.postalCodeAndCityRequired == true)
                            || (selectedTicket.ticketType.emailMandatory == true || selectedTicket.ticketType.emailRequired == true)
                            || (selectedTicket.ticketType.phoneMandatory == true || selectedTicket.ticketType.phoneRequired == true)
                            || (selectedTicketInfo?.customText1)
                            || (selectedTicketInfo?.customText2)
                            || (selectedTicketInfo?.customText3)
                            || (selectedTicketInfo?.customText4)
                            || (additionalFields?.length > 0);

                        return (
                            <div className="ticketAddress pt-4 ps-4 pe-4 pb-2 mb-4" key={address.ticketId}>
                                {selectedTicketInfo &&
                                    <div className="mb-3">
                                        <div className={"row fw-semibold" + (isAddressRequired ? " mb-4" : "")}>
                                            <div className="text-start col-6 col-md-9">
                                                <p className="mb-0">{selectedTicketInfo.name}</p>
                                                {address.seatDetails && Object.keys(address.seatDetails).length > 0 && <div className="form-text">{resources.customerPage?.SeatingPlace}: {resources.customerPage?.Row} {address.seatDetails.rowName}, {resources.customerPage?.Seat} {address.seatDetails.name}</div>}
                                            </div>
                                            <div className="text-end col-4 col-md-2 fs-6">{selectedTicket?.currency} {selectedTicket?.price?.toFixed(2)}</div>
                                            <div className="text-end col-2 col-md-1 fs-6 ticketDelete" onClick={() => removeTicketFromBasket(address.ticketId)}>X</div>
                                        </div>
                                    </div>
                                }

                                {/* {isAddressRequired && <hr className="mt-5 mb-5"></hr>} */}

                                {additionalFields?.length > 0 && additionalFields.map((field) => (
                                    mapAdditionalFields(field, address)
                                ))}

                                {(selectedTicket.ticketType.salutationMandatory == true || selectedTicket.ticketType.salutationRequired == true) &&

                                    <div className="mb-3 row">
                                        <label className="ticketinoLabel mb-2 col-12 text fs-6 ">
                                            {resources.customerPage?.labelGender}*
                                        </label>
                                        <div className="col-sm-9 col-md-10 col-12">
                                            <div>
                                                <select
                                                    className="ticketinoInput selectNum form-select"
                                                    aria-label=""
                                                    id="salutation"
                                                    name="salutation"
                                                    value={address.salutation}
                                                    onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                                                >
                                                    <option value=""></option>
                                                    <option value={resources.customerPage?._Male}>{resources.customerPage?._Male}</option>
                                                    <option value={resources.customerPage?._Female}>{resources.customerPage?._Female}</option>
                                                    <option value={resources.customerPage?._Divers}>{resources.customerPage?._Divers}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {(selectedTicket.ticketType.companyMandatory == true || selectedTicket.ticketType.companyRequired == true) &&

                                    <div className="mb-3 row">
                                        <label className="ticketinoLabel mb-2 col-sm-3 col-md-2 col-12 text fs-6 mb-2 text-start" htmlFor={"companyTicket"}>
                                            {resources.customerPage?.labelCompany}*
                                        </label>
                                        <div className="col-sm-9 col-md-10 col-12">
                                            <input
                                                type="text"
                                                name="company"
                                                className="ticketinoInput form-control inputCodeFirstname"
                                                id={"company" + address.ticketId}
                                                value={address.company}
                                                onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                                            />
                                        </div>
                                    </div>
                                }
                                {(selectedTicket.ticketType.firstNameMandatory == true || selectedTicket.ticketType.firstNameRequired == true) &&

                                    <div className="mb-3 row">
                                        <label className="ticketinoLabel mb-2 col-sm-3 col-md-2 col-12 text fs-6 mb-2 text-start" htmlFor={"firstnameTicket"}>
                                            {resources.customerPage?.labelFirstname}*
                                        </label>
                                        <div className="col-sm-9 col-md-10 col-12">
                                            <input
                                                type="text"
                                                name="firstName"
                                                className="ticketinoInput form-control inputCodeFirstname"
                                                id={"firstName" + address.ticketId}
                                                value={address.firstName}
                                                onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                                            />
                                        </div>
                                    </div>
                                }
                                {(selectedTicket.ticketType.nameMandatory == true || selectedTicket.ticketType.nameRequired == true) &&
                                    <div className="mb-3 row">
                                        <label className="ticketinoLabel mb-2 col-sm-3 col-md-2 col-12 text fs-6 mb-2 text-start" htmlFor={"lastnameTicket"}>
                                            {resources.customerPage?.labelFamilyname}*
                                        </label>
                                        <div className="col-sm-9 col-md-10 col-12">
                                            <input
                                                type="text"
                                                name="name"
                                                className="ticketinoInput form-control inputCodeLastname"
                                                id={"name" + address.ticketId}
                                                value={address.name}
                                                onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                                            />
                                        </div>
                                    </div>
                                }
                                {(selectedTicket.ticketType.addressMandatory == true || selectedTicket.ticketType.addressRequired == true) &&

                                    <div className="mb-3 row">
                                        <label className="ticketinoLabel mb-2 col-sm-3 col-md-2 col-12 text fs-6 mb-2 text-start" htmlFor={"streetTicket"}>
                                            {resources.customerPage?.labelStreet}*
                                        </label>
                                        <div className="col-sm-9 col-md-10 col-12">
                                            <input
                                                type="text"
                                                name="street"
                                                className="ticketinoInput form-control inputCodeStreet"
                                                id={"street" + address.ticketId}
                                                value={address.street}
                                                onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                                            />
                                        </div>
                                    </div>
                                }
                                {(selectedTicket.ticketType.postalCodeAndCityMandatory == true || selectedTicket.ticketType.postalCodeAndCityRequired == true) &&

                                    <div className="mb-3 row">
                                        <label className="ticketinoLabel mb-2 col-sm-3 col-md-2 col-12 text fs-6 mb-2 text-start" htmlFor={"plzTicket"}>
                                            {resources.customerPage?.labelPlz}*
                                        </label>
                                        <div className="col-sm-9 col-md-10 col-12">
                                            <input
                                                type="text"
                                                name="postCode"
                                                className="ticketinoInput form-control inputCodePLZ"
                                                id={"postCode" + address.ticketId}
                                                value={address.postCode}
                                                onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                                            />
                                        </div>
                                    </div>
                                }
                                {(selectedTicket.ticketType.postalCodeAndCityMandatory == true || selectedTicket.ticketType.postalCodeAndCityRequired == true) &&
                                    <div className="mb-3 row">
                                        <label className="ticketinoLabel mb-2 col-sm-3 col-md-2 col-12 text fs-6 mb-2 text-start" htmlFor={"placeTicket"}>
                                            {resources.customerPage?.labelPlace}*
                                        </label>
                                        <div className="col-sm-9 col-md-10 col-12">
                                            <input
                                                type="text"
                                                name="city"
                                                className="ticketinoInput form-control inputCodePlace"
                                                id={"city" + address.ticketId}
                                                value={address.city}
                                                onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                                            />
                                        </div>
                                    </div>
                                }
                                {(selectedTicket.ticketType.emailMandatory == true || selectedTicket.ticketType.emailRequired == true) &&
                                    <div className="mb-3 row">
                                        <label className="ticketinoLabel mb-2 col-sm-3 col-md-2 col-12 text fs-6 mb-2 text-start" htmlFor="emailTicket">
                                            {resources.customerPage?.labelEmail}*
                                        </label>
                                        <div className="col-sm-9 col-md-10 col-12">
                                            <input
                                                type="text"
                                                name="email"
                                                className="ticketinoInput form-control inputCodeMail"
                                                id={"email" + address.ticketId}
                                                placeholder="Example@gmail.com"
                                                value={address.email}
                                                onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                                            />
                                        </div>
                                    </div>
                                }
                                {(selectedTicket.ticketType.phoneMandatory == true || selectedTicket.ticketType.phoneRequired == true) &&
                                    <div className="mb-3 row">
                                        <label className="ticketinoLabel mb-2 col-sm-3 col-md-2 col-12 text fs-6 mb-2 text-start" htmlFor={"mobileTicket"}>
                                            {resources.customerPage?.labelMobile}*
                                        </label>
                                        <div className="col-sm-9 col-md-10 col-12">
                                            <input
                                                type="text"
                                                name="mobile"
                                                className="ticketinoInput form-control inputCodeStreet"
                                                id={"mobile" + address.ticketId}
                                                value={address.mobile}
                                                onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                                            />
                                        </div>
                                    </div>
                                }
                                {(selectedTicketInfo?.customText1) && (
                                    <div className="mb-3 row">
                                        <label className="ticketinoLabel mb-2 col-sm-3 col-md-2 col-12 text fs-6 mb-2 text-start" htmlFor={"mobileTicket"}>
                                            {selectedTicketInfo?.customText1}{selectedTicketInfo?.customText1Mandatory && "*"}
                                        </label>
                                        <div className="col-sm-9 col-md-10 col-12">
                                            <input
                                                type="text"
                                                name="customValue1"
                                                className="ticketinoInput form-control inputCodeStreet"
                                                id={"customValue1" + address.ticketId}
                                                value={address.customValue1}
                                                onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                                            />
                                        </div>
                                    </div>
                                )}

                                {(selectedTicketInfo?.customText2) && (
                                    <div className="mb-3 row">
                                        <label className="ticketinoLabel mb-2 col-sm-3 col-md-2 col-12 text fs-6 mb-2 text-start" htmlFor={"mobileTicket"}>
                                            {selectedTicketInfo?.customText2}{selectedTicketInfo?.customText2Mandatory && "*"}
                                        </label>
                                        <div className="col-sm-9 col-md-10 col-12">
                                            <input
                                                type="text"
                                                name="customValue2"
                                                className="ticketinoInput form-control inputCodeStreet"
                                                id={"customValue2" + address.ticketId}
                                                value={address.customValue2}
                                                onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                                            />
                                        </div>
                                    </div>
                                )}

                                {(selectedTicketInfo?.customText3) && (
                                    <div className="mb-2 row">
                                        <div className="col-12">
                                            <div className="form-check">
                                                <input
                                                    className="ticketinoInput form-check-input"
                                                    type="checkbox"
                                                    name="customValue3"
                                                    id={"customValue3" + address.ticketId}
                                                    checked={address.customValue3}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setTicketsAddress((prevTicketsAddress) => {
                                                                const updatedTicketAddress = prevTicketsAddress.map((ta) => {
                                                                    if (ta.ticketId === address.ticketId) {
                                                                        return { ...ta, customValue3: true };
                                                                    }
                                                                    return ta;
                                                                });
                                                                return updatedTicketAddress;
                                                            });
                                                        } else {
                                                            setTicketsAddress((prevTicketsAddress) => {
                                                                const updatedTicketAddress = prevTicketsAddress.map((ta) => {
                                                                    if (ta.ticketId === address.ticketId) {
                                                                        return { ...ta, customValue3: false };
                                                                    }
                                                                    return ta;
                                                                });
                                                                return updatedTicketAddress;
                                                            });
                                                        }
                                                    }}
                                                />
                                                <label className="ticketinoLabel mb-2 form-check-label text-start text-center" htmlFor={"customValue3" + address.ticketId}>
                                                    {selectedTicketInfo?.customText3}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {(selectedTicketInfo?.customText4) && (
                                    <div className="mb-2 row">
                                        <div className="col-12">
                                            <div className="form-check">
                                                <input
                                                    className="ticketinoInput form-check-input"
                                                    type="checkbox"
                                                    name="customValue4"
                                                    id={"customValue4" + address.ticketId}
                                                    checked={address.customValue4}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setTicketsAddress((prevTicketsAddress) => {
                                                                const updatedTicketAddress = prevTicketsAddress.map((ta) => {
                                                                    if (ta.ticketId === address.ticketId) {
                                                                        return { ...ta, customValue4: true };
                                                                    }
                                                                    return ta;
                                                                });
                                                                return updatedTicketAddress;
                                                            });
                                                        } else {
                                                            setTicketsAddress((prevTicketsAddress) => {
                                                                const updatedTicketAddress = prevTicketsAddress.map((ta) => {
                                                                    if (ta.ticketId === address.ticketId) {
                                                                        return { ...ta, customValue4: false };
                                                                    }
                                                                    return ta;
                                                                });
                                                                return updatedTicketAddress;
                                                            });
                                                        }
                                                    }}
                                                />
                                                <label className="ticketinoLabel mb-2 form-check-label text-start text-center" htmlFor={"customValue4" + address.ticketId}>
                                                    {selectedTicketInfo?.customText4}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    })
                }
            </div>
        )
    }


    const mapCrossSellingTicketTypes = () => {
        let ticketTypesSorted = [];

        if (crossSellingTicketTypes && crossSellingTicketTypes.length > 0) {
            ticketTypesSorted = [...crossSellingTicketTypes].sort((a, b) => a.sortOrder - b.sortOrder);
        }

        ticketTypesSorted = ticketTypesSorted.map((ticketType) => {

            const ticketTypeInfo = ticketType.info?.find(info => info.languageId === selectedLanguageCode) ?? ticketType.info?.find(info => info.languageId === 0);

            //taking the default value when info doesnt exist
            return { ...ticketType, info: ticketTypeInfo };
        });

        let ticketTypeClassName = "ticketObjectDiv pt-2 pb-2";
        let ticketTypeParentClassName = "";

        if (showTicketTypesAsList == "false") {
            ticketTypeClassName += " showAsBox p-2"
            ticketTypeParentClassName = "row";
        }

        return (
            <div className="mb-5">
                {showTicketTypesAsList == "false" ? <></> :
                    <div className="ticketObjectDiv row" >
                        <div className="col-md-8 col-6 fs-6 fw-bold">
                            {resources.ticketPage?.Kategorie}
                        </div>
                        <div className="ticketinoText col-md-2 col-3 text-start p-0">
                            <p className="m-0 fw-bold">{resources.ticketPage?.PriceText}</p> {resources.ticketPage?.IncludeMwst}
                        </div>
                        <div className="ticketinoText col-md-2 col-3 text-start fw-bold p-0">
                            {resources.ticketPage?.Amount}
                        </div>
                    </div>}
                <hr></hr>
                <div className={ticketTypeParentClassName}>
                    {crossSellingTicketTypes &&
                        crossSellingTicketTypes.length > 0 &&
                        ticketTypesSorted.map((tt, index) => (
                            <div className={showTicketTypesAsList == "false" ? "col-md-6" : ""} key={index}>
                                {
                                    tt.availability?.status === 0 &&
                                    (
                                        <>
                                            <div className={ticketTypeClassName}>
                                                <div className="row">
                                                    <div className="col-md-8 col-6 p-0">
                                                        <label className="ticketinoText fs-6">
                                                            {tt.info?.name}
                                                        </label>
                                                        {showTicketDescription == "true" && <div className="ticketinoText description text-secondary">
                                                            {tt.info?.description}
                                                        </div>}
                                                    </div>
                                                    <div className={`col-md-2 col-3 ${showTicketTypesAsList == "false" ? "text-center" : "text-start"} p-0`}>
                                                        <label className="ticketinoText">
                                                            {tt.currency} {tt.updatedPrice}.-
                                                        </label>
                                                    </div>
                                                    <div className="col-md-2 col-3 p-0">
                                                        <select
                                                            value={0}
                                                            className="ticketinoSelect form-select"
                                                            onChange={(e) => onCrossSellingTicketTypeChange(e, tt.id)}
                                                            disabled={disabledTickets.includes(`${tt.id}`)}
                                                        >
                                                            {Array.from(
                                                                Array(
                                                                    tt.availability?.availableTickets + 1
                                                                ),
                                                                (e, i) => {
                                                                    return (
                                                                        <option key={i} value={i}>
                                                                            {i}
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>
                                                {tickets?.length > 0 && tickets?.some(t => t.ticketTypeId == tt.id) &&
                                                    <div className="row">
                                                        <div className="col-12 p-0">
                                                            <div class="alert alert-success p-2 mt-1" role="alert" >
                                                                {tickets.filter(t => t.ticketTypeId === tt.id).length} {resources.customerPage?.TicketsAddedToOrder}
                                                            </div>
                                                        </div>
                                                    </div>}
                                            </div>
                                            {showTicketTypesAsList == "false" ? <></> : <hr></hr>}
                                        </>
                                    )}
                            </div>
                        ))}
                </div>
            </div>
        );
    }

    //----HTML Display------
    return (
        <div className="page-container">
            {languageSelectDiv()}
            <div>
                {(!(tickets?.length > 0) & !loading) ? <div>
                    <div className="flex-end mb-5 col text-center">
                        <button className="ticketinoButton btn mx-2 button btn-light" onClick={() => props.changePage(-1)} >
                            {resources.customerPage?.buttonLabelNewBooking}
                        </button>
                    </div>
                </div> : null}
                {(!(tickets) & !loading) ? <div className="alert alert-warning" role="alert">
                    {resources.summarypage?.reserveTicket}
                </div> : null}
            </div>
            {loading ? <Loading /> : tickets?.length > 0 ? <>
                {errorMessage != "" ? <div className="container">
                    <div className="row">
                        <div id="ticketinoErrorMessage" className="ticketinoText ticketinoError mb-3">
                            <div className="col-md-8 col-6 p-0">
                                {errorMessage}
                            </div>
                        </div>
                    </div>
                </div> : null}
                {crossSellingTicketTypes != null && crossSellingTicketTypes.length > 0 &&
                    <div className="container">
                        <p className="ticketinoText text titleStyle text-start fs-5 fw-semibold mb-2">{resources.customerPage?.recommendedTickets}</p>
                        {mapCrossSellingTicketTypes()}
                    </div>}
                {mapTicketsAddress()}
                <div className="mb-5">
                    <div className="container">
                        <div className="mb-3 row">
                            <p className="ticketinoText text titleStyle text-start fs-5 fw-semibold mb-2">{resources.customerPage?.customerAddress}</p>
                        </div>
                        {neededFields.includes("salutation") &&

                            <div className="mb-3 row">
                                <label className="ticketinoLabel col-12 text fs-6 mb-2">
                                    {resources.customerPage?.labelGender}*
                                </label>
                                <div className="col-12">
                                    <div>
                                        <select
                                            className="ticketinoInput selectNum form-select"
                                            aria-label=""
                                            id="salutation"
                                            name="salutation"
                                            value={user.salutation}
                                            onChange={onInputChangeOrder}
                                        >
                                            <option value=""></option>
                                            <option value={resources.customerPage?._Male}>{resources.customerPage?._Male}</option>
                                            <option value={resources.customerPage?._Female}>{resources.customerPage?._Female}</option>
                                            <option value={resources.customerPage?._Divers}>{resources.customerPage?._Divers}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        }
                        {neededFields.includes("company") &&
                            <div className="mb-3 row">
                                <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="company">
                                    {resources.customerPage?.labelCompany}*
                                </label>
                                <div className="col-12">
                                    <input
                                        type="text"
                                        className="ticketinoInput form-control inputCodeFirstname"
                                        name="company"
                                        value={user.company}
                                        id="company"
                                        onChange={onInputChangeOrder}
                                    />
                                </div>
                            </div>
                        }
                        {(neededFields.includes("firstName")) &&

                            <div className="mb-3 row">
                                <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="firstname">
                                    {resources.customerPage?.labelFirstname}*
                                </label>
                                <div className="col-12">
                                    <input
                                        type="text"
                                        name="firstName"
                                        className="ticketinoInput form-control inputCodeFirstname"
                                        value={user.firstName}
                                        id="firstName"
                                        onChange={onInputChangeOrder}
                                    />
                                </div>
                            </div>

                        }
                        {(neededFields.includes("name")) &&
                            <div className="mb-3 row">
                                <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="lastname">
                                    {resources.customerPage?.labelFamilyname}*
                                </label>
                                <div className="col-12">
                                    <input
                                        type="text"
                                        name="name"
                                        className="ticketinoInput form-control inputCodeLastname"
                                        value={user.name}
                                        id="name"
                                        onChange={onInputChangeOrder}
                                    />
                                </div>
                            </div>
                        }
                        <div className="mb-3 row">
                            <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="email">
                                {resources.customerPage?.labelEmail}*
                            </label>
                            <div className="col-12">
                                <input
                                    type="text"
                                    name="email"
                                    className="ticketinoInput form-control inputCodeMail"
                                    value={user.email}
                                    id="email"
                                    placeholder="Example@gmail.com"
                                    onChange={onInputChangeOrder}
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="ticketinoLabel col-12 text fs-6 mb-2 text-start" htmlFor="emailRepeat">
                                {resources.customerPage?.labelEmailRepeat}*
                            </label>
                            <div className="col-12">
                                <input
                                    type="text"
                                    name="emailCheck"
                                    className="ticketinoInput form-control inputCodeMail"
                                    id="emailCheck"
                                    value={user.emailCheck}
                                    placeholder="Example@gmail.com"
                                    onChange={onInputChangeOrder}
                                />
                            </div>
                        </div>
                        {neededFields.includes("mobile") &&
                            <div className="mb-3 row">
                                <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start">
                                    {resources.customerPage?.labelMobile}*
                                </label>
                                <div className="col-12">
                                    <input
                                        type="text"
                                        name="mobile"
                                        className="ticketinoInput form-control inputCodeStreet"
                                        value={user.mobile}
                                        id="mobile"
                                        onChange={onInputChangeOrder}
                                    />
                                </div>
                            </div>
                        }
                        {neededFields.includes("telephone") &&
                            <div className="mb-3 row">
                                <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="telephone">
                                    {resources.customerPage?.labelTelephone}*
                                </label>
                                <div className="col-12">
                                    <input
                                        type="text"
                                        name="telephone"
                                        className="ticketinoInput form-control inputCodeStreet"
                                        id="telephone"
                                        value={user.telephone}
                                        onChange={onInputChangeOrder}
                                    />
                                </div>
                            </div>
                        }
                        {neededFields.includes("street") &&
                            <div className="mb-3 row">
                                <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="street">
                                    {resources.customerPage?.labelStreet}*
                                </label>
                                <div className="col-12">
                                    <input
                                        type="text"
                                        name="street"
                                        className="ticketinoInput form-control inputCodeStreet"
                                        id="street"
                                        value={user.street}
                                        onChange={onInputChangeOrder}
                                    />
                                </div>
                            </div>
                        }
                        {neededFields.includes("postCode") &&
                            <div className="mb-3 row">
                                <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="plz">
                                    {resources.customerPage?.labelPlz}*
                                </label>
                                <div className="col-12">
                                    <input
                                        type="text"
                                        name="postCode"
                                        className="ticketinoInput form-control inputCodePLZ"
                                        id="postCode"
                                        value={user.postCode}
                                        onChange={onInputChangeOrder}
                                    />
                                </div>
                            </div>
                        }
                        {neededFields.includes("city") &&
                            <div className="mb-3 row">
                                <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="place">
                                    {resources.customerPage?.labelPlace}*
                                </label>
                                <div className="col-12">
                                    <input
                                        type="text"
                                        name="city"
                                        className="ticketinoInput form-control inputCodePlace"
                                        id="city"
                                        value={user.city}
                                        onChange={onInputChangeOrder}
                                    />
                                </div>
                            </div>
                        }
                        <div className="mb-3 row">
                            <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="country">
                                {resources.customerPage?.labelCountry}*
                            </label>
                            <div className="col-12">
                                {countryArray.length > 0 ?
                                    <div>
                                        <select
                                            className="ticketinoInput selectNum form-select"
                                            aria-label=""
                                            name="countryId"
                                            value={user.countryId}
                                            onChange={onInputChangeOrder}
                                            id="countryId"
                                        >
                                            <option defaultValue="null" ></option>
                                            {countryArray.map((value, key) => {
                                                return (
                                                    <option key={key} value={value.id}>{value.name}</option>
                                                )
                                            })}
                                        </select>
                                    </div> : null}
                            </div>
                        </div>
                    </div>
                </div>
                {neededFields.includes("deliveryAddress") &&
                    <div className="container mt-3">
                        <p className="ticketinoText text titleStyle text-start fs-5 fw-semibold mb-2">{resources.customerPage?.deliveryAddress}</p>
                        <div className="form-check mb-3">
                            <input
                                className="ticketinoInput form-check-input"
                                checked={user.deliveryActive}
                                name="deliveryActive"
                                type="checkbox"
                                id="deliveryActive"
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setUser({ ...user, deliveryActive: true })
                                    } else {
                                        setUser({ ...user, deliveryActive: false })
                                    }
                                }}
                            />
                            <label className="ticketinoLabel mb-2 form-check-label text-start text-center" htmlFor="deliveryActive">
                                {resources.customerPage?.differentDeliveryText}
                            </label>
                        </div>
                    </div>

                }

                {(neededFields.includes("deliveryAddress") && user.deliveryActive == true) &&
                    <div className="container">
                        <div className="mb-3 row">
                            <label className="ticketinoLabel mb-2 col-12 text-start">
                                {resources.customerPage?.labelGender}*
                            </label>
                            <div className="col-12">
                                <div>
                                    <select
                                        className="ticketinoInput selectNum form-select"
                                        aria-label=""
                                        id="deliverySalutation"
                                        name="deliverySalutation"
                                        value={user.deliverySalutation}
                                        onChange={onInputChangeOrder}
                                    >
                                        <option value=""></option>
                                        <option value={resources.customerPage?._Male}>{resources.customerPage?._Male}</option>
                                        <option value={resources.customerPage?._Female}>{resources.customerPage?._Female}</option>
                                        <option value={resources.customerPage?._Divers}>{resources.customerPage?._Divers}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="firstnameDelivery">
                                {resources.customerPage?.labelFirstname}*
                            </label>
                            <div className="col-12">
                                <input
                                    type="text"
                                    name="deliveryFirstName"
                                    className="ticketinoInput form-control inputCodeFirstname"
                                    id="deliveryFirstName"
                                    value={user.deliveryFirstName}
                                    onChange={onInputChangeOrder}
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="lastnameDelivery">
                                {resources.customerPage?.labelFamilyname}*
                            </label>
                            <div className="col-12">
                                <input
                                    type="text"
                                    name="deliveryLastName"
                                    className="ticketinoInput form-control inputCodeLastname"
                                    id="deliveryLastName"
                                    value={user.deliveryLastName}
                                    onChange={onInputChangeOrder}
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="lastnameDelivery">
                                {resources.customerPage?.labelCompany}
                            </label>
                            <div className="col-12">
                                <input
                                    type="text"
                                    name="deliveryCompanyName"
                                    className="ticketinoInput form-control inputCodeCompanyName"
                                    id="deliveryCompanyName"
                                    value={user.deliveryCompanyName}
                                    onChange={onInputChangeOrder}
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="streetDelivery">
                                {resources.customerPage?.labelStreet}*
                            </label>
                            <div className="col-12">
                                <input
                                    type="text"
                                    name="deliveryStreet"
                                    className="ticketinoInput form-control inputCodeStreet"
                                    id="deliveryStreet"
                                    value={user.deliveryStreet}
                                    onChange={onInputChangeOrder}
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="plzDelivery">
                                {resources.customerPage?.labelPlz}*
                            </label>
                            <div className="col-12">
                                <input
                                    type="text"
                                    name="deliveryPostCode"
                                    className="ticketinoInput form-control inputCodePLZ"
                                    id="deliveryPostCode"
                                    value={user.deliveryPostCode}
                                    onChange={onInputChangeOrder}
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="placeDelivery">
                                {resources.customerPage?.labelPlace}*
                            </label>
                            <div className="col-12">
                                <input
                                    type="text"
                                    name="deliveryCity"
                                    className="ticketinoInput form-control inputCodePlace"
                                    id="deliveryCity"
                                    value={user.deliveryCity}
                                    onChange={onInputChangeOrder}
                                />
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="ticketinoLabel mb-2 col-12 text fs-6 mb-2 text-start" htmlFor="countryDelivery">
                                {resources.customerPage?.labelCountry}*
                            </label>
                            <div className="col-12">
                                {countryArray.length > 0 ?
                                    <div>
                                        <select
                                            className="ticketinoSelect selectNum form-select "
                                            aria-label=""
                                            name="deliveryCountryId"
                                            id="deliveryCountryId"
                                            value={user.deliveryCountryId}
                                            onChange={onInputChangeOrder}
                                        >
                                            <option defaultValue="null"></option>
                                            {countryArray.map((value, key) => {
                                                return (
                                                    <option key={key} value={value.id}>{value.name}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </div>
                }
                <div className="container mt-3">
                    <div className="form-check mb-3">
                        <input
                            className="ticketinoInput form-check-input"
                            name="AcceptAGB"
                            type="checkbox"
                            id="AGBcheckbox"
                            checked={userAcceptAGB}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setUserAcceptAGB(true)
                                } else {
                                    setUserAcceptAGB(false)
                                }
                            }}
                        />
                        <label className="ticketinoLabel mb-2 form-check-label text-start" htmlFor="AGBcheckbox">
                            <div dangerouslySetInnerHTML={{ __html: resources.customerPage?.agbMessage }} />
                        </label>
                    </div>
                    <p className="ticketinoText mb-5">
                        *{resources.customerPage?.fieldMessage}
                    </p>

                    <button className="button btn-grey btn-ticketino-large mb-3 mb-3" onClick={() => props.changePage(-1)} >
                        {resources.customerPage?.buttonLabelPrevious}
                    </button>
                    <button className="button btn-orange btn-ticketino-large mb-3 float-end" disabled={!(userAcceptAGB && tickets?.length > 0)} onClick={updateAddress} >
                        {resources.customerPage?.buttonLabelContinue}
                    </button>
                </div>
            </> : null}
        </div>
    )
}

export default CustomerForm;